import styled from 'styled-components';

export const Container = styled.div`
  margin-top: -100px;

  @media (max-width: 1076px) {
    margin-top: -80px;
  }

  @media (max-width: 767px) {
    margin-top: -60px;
  }

  ${({ isEmbed }) =>
    isEmbed &&
    `
    margin: 0px !important;
  `}
`;

export const Calculator = styled.div`
  width: 100%;
  max-width: 990px;
  background: white;
  margin: 0px auto;
  padding: 46px 40px 40px 40px;
  box-shadow: ${({ isEmbed }) => (isEmbed ? 'none' : '0px 30px 60px rgba(11, 26, 33, 0.15)')};

  .hvac-duct--iframe {
    justify-content: center;
  }

  .conversion-link {
    font-size: var(--font-size-16);
    font-weight: var(--font-weight-500);
    margin-left: 8px;
  }

  .calculate {
    width: 100%;
  }

  a {
    color: var(--titan-blue-3);
  }

  .duct-type-container {
    width: 100%;
  }

  .MuiGrid2-container {
    margin-bottom: 30px;

    .external-helper-text {
      padding-top: 34px;
    }
  }

  .duct-type--radio-group {
    display: flex;
  }

  @media (max-width: 1076px) {
    width: ${({ isEmbed }) => (isEmbed ? '100%' : '90%')};
  }

  @media (max-width: 767px) {
    padding: 36px 25px 25px 25px;
  }

  .gate-form--subscribe-marketo-form {
    box-shadow: none !important;

    .slick-list {
      height: 100% !important;

      .data-layer-form {
        flex-direction: row !important;

        .text-field-input {
          width: 100% !important;
        }
      }
    }
  }
`;

export const Results = styled.div`
  margin-top: 30px;
  padding: 20px;
  border: 1px solid var(--grey-4);
  background: var(--titan-blue-1);
`;

export const UtilityCalculatorContainer = styled.div`
  width: 100%;
  margin: 0px auto;

  .utility-calculator--container-title {
    margin-bottom: 30px;
  }

  .utility-calculator--units-label {
    margin: 0;
    height: 100%;
    display: flex;
    padding-top: 24px;
    align-items: center;
  }

  .utility-calculator--submit-button {
    width: 100%;
    margin-top: 48px;
    height: 58px;
  }

  .utility-calculator--result {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 20px;
    border: 1px solid var(--grey-4);
    background: var(--titan-blue-1);
    margin-bottom: 0;
  }

  .utility-calculator--result > * {
    margin-bottom: 0px;
    margin-right: 15px;
    width: fit-content;
    line-height: 28px;
  }

  @media (max-width: 599px) {
    .utility-calculator--submit-button {
      margin-top: 0px;
    }

    .utility-calculator--result {
      margin-top: 20px;
    }
  }
`;

export const UtilityFunctions = styled.div`
  .section-faq--container {
    max-width: 1070px !important;
    padding: 60px 28px 0px !important;

    .section-faq--faq-container {
      margin: 0px !important;
    }
  }
`;

export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: row;

  .text-field-wrapper {
    flex: 2;

    @media (max-width: 991px) {
      flex: 2;
    }
  }

  p {
    flex: 1;
    margin: 16px 10px 10px;

    @media (max-width: 991px) {
      text-align: center;
    }

    @media (max-width: 767px) {
      font-size: var(--font-size-13);
      margin: 12px 10px 10px;
    }
  }
`;

export const UncommonValue = styled.div`
  background-color: var(--grey-3);
  border-radius: 2px;
  width: 223px;
  padding: 7px 10px;
  margin-top: 5px;

  p {
    margin: 0px;
  }
`;

export const ToggleButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 0 40px;

  .MuiToggleButton-root {
    width: 100%;
    font-size: var(--font-size-25);
    font-family: var(--font-family);
    text-transform: none;
    height: 58px;
    border-radius: 0;
    background: #fff !important;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.85);

    &.Mui-selected {
      color: var(--titan-blue-3) !important;
      border-color: var(--titan-blue-3) !important;
    }

    &:focus-within {
      box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
    }
  }
`;
